import { Button } from "@/components/ui/button";
import { Maximize2, PhoneOff } from "lucide-react";
import React, { useEffect } from "react";
import { useZoomMeeting } from "../context/ZoomMeetingContext";

const isInvalid = (val) => !val || val === "null" || val === "undefined";
const ZOOM_DEBUG = process.env.NODE_ENV !== "production";

export default function ZoomMeetingWidget() {
  const { session, isMinimized, isActive, expandMeeting, leaveMeeting, uiPhase } = useZoomMeeting();

  useEffect(() => {
    if (!ZOOM_DEBUG) return undefined;
    if (isActive && isMinimized && session) {
      console.debug("[Zoom][ZoomMeetingWidget] mounted");
      return () => console.debug("[Zoom][ZoomMeetingWidget] unmounted");
    }
    return undefined;
  }, [isActive, isMinimized, session]);

  if (!isActive || !isMinimized || !session) return null;

  const label = session.isAudioOnly ? "Voice call" : "Video meeting";

  return (
    <div
      style={{
        position: "fixed",
        bottom: 16,
        right: 16,
        width: 320,
        zIndex: 9999,
        borderRadius: 12,
        overflow: "hidden",
        boxShadow: "0 12px 40px rgba(0,0,0,0.4)",
        background: "linear-gradient(180deg, #1a1a2e 0%, #16213e 100%)",
        color: "#fff",
        fontFamily: "inherit",
      }}
      role="region"
      aria-label="Minimized meeting"
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 12px",
          gap: 8,
          borderTop: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <div style={{ minWidth: 0 }}>
          <p style={{ margin: 0, fontSize: 13, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {label} in progress
          </p>
          <p style={{ margin: "2px 0 0", fontSize: 11, opacity: 0.7 }}>
            {uiPhase === "reconnecting" ? "Reconnecting…" : "Tap expand to return"}
          </p>
        </div>
        <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
          <Button
            size="sm"
            variant="secondary"
            onClick={expandMeeting}
            aria-label="Expand meeting"
            style={{ height: 32, padding: "0 10px" }}
          >
            <Maximize2 size={14} style={{ marginRight: 4 }} />
            Expand
          </Button>
          <Button
            size="sm"
            variant="destructive"
            onClick={() => void leaveMeeting("user")}
            aria-label="Leave meeting"
            style={{ height: 32, padding: "0 10px" }}
          >
            <PhoneOff size={14} style={{ marginRight: 4 }} />
            Leave
          </Button>
        </div>
      </div>
      {!isInvalid(session.incidentId) && (
        <p style={{ margin: 0, padding: "0 12px 10px", fontSize: 11, opacity: 0.55 }}>
          You can continue using the app — the meeting stays connected.
        </p>
      )}
    </div>
  );
}
